<template>
  <v-card flat color="transparent" class="mt-n9">
    <v-row>
      <v-col cols="12">
        <v-radio-group v-model="questionAnswer" :error-messages="errorMessage">
          <v-radio
            v-for="opt in question.questionOpts"
            :key="opt.questionOptId"
            :label="opt.optLabel"
            :value="opt.questionOptId"
            :color="themeColor"
          >
            <template #label>
              <v-img
                v-if="opt.attachment"
                class="mr-2"
                max-width="100px"
                max-height="100px"
                contain
                :src="opt.attachment.filePathUri"
              ></v-img>
              <span>{{ opt.optLabel }}</span>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { validate } from "vee-validate";
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary"
    },
    responseAnswer: Object,
  },
  computed: {
    questionAnswers() {
      let qa = null;
      if (this.questionAnswer != null) {
        qa = [this.questionAnswer];
      } else {
        qa = [];
      }
      return {
        questionId: this.question.questionId,
        questionMatrixId: null,
        questionAnswerVals: qa,
        questionType: this.question.questionType,
      };
    },
  },
  data() {
    return {
      questionAnswer: null,
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
    };
  },
  methods: {
    async checkValidation() {
      let rules = {};
      if (this.question.required) {
        rules["required"] = true;
      }
      let rst = await validate(this.questionAnswer, rules, { name: "이 " });
      this.$emit("update:isValid", rst.valid);
      this.errorMessage = rst.errors;
    },
    setQuestionAnswer() {
      this.questionAnswer =
        this.responseAnswer.response.length > 0
          ? Number(this.responseAnswer.response[0].answerVal)
          : null;
    },
  },
  watch: {
    async questionAnswer() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

